import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { truncate } from '../../lib/functions';

const MAX_TITLE_LENGTH = 110;

class DuplicatedPurchase extends Component {
  ignoreDuplicatedPurchase() {
    this.props.ignoreDuplicatedPurchase();
  }

  renderSimilarPurchase() {
    const { duplicatedPurchase, duplicatedPurchase: { memberships } } = this.props;
    const contributors = memberships.filter(m => m.status === 'accepted');
    return (
      <div className="divider pt-3 pb-5">
        <p>
          <strong>
            {truncate(duplicatedPurchase.product.name, MAX_TITLE_LENGTH)}
          </strong>
          <br />

          <span className="cool-grey">
            <FormattedMessage
              id="duplicatedPurchase.similarPurchaseComparison"
              defaultMessage="It has {i, plural, one {# invitee} other {# invitees}}
                and {c, plural, =0 {no contributors} one {# contributor} other {# contributors}}."
              values={{
                i: memberships.length,
                c: contributors.length
              }}
            />
          </span>
        </p>
      </div>
    );
  }

  renderButtons() {
    const { duplicatedPurchase: { slug } } = this.props;

    return (
      <div className="float-right">
        <button
          type="button"
          className="btn btn-secondary mr-3"
          onClick={() => this.ignoreDuplicatedPurchase()}
        >
          <FormattedMessage
            id="duplicatedPurchase.createNew"
            defaultMessage="Create new group"
          />
        </button>
        <a
          href={`/purchases/${slug}`}
          className="btn btn-primary"
          target="_top"
        >
          <FormattedMessage
            id="duplicatedPurchase.goToExisting"
            defaultMessage="Go to existing group"
          />
        </a>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="modal-section modal-title text-center blue full">
          <h1>
            <FormattedMessage
              id="duplicatedPurchase.title"
              defaultMessage="Duplicate Group?"
            />
          </h1>
        </div>
        <div className="modal-section">
          <p>
            <span role="img" aria-label="hmm">🤔</span>
            {' '}
            <FormattedMessage
              id="duplicatedPurchase.text"
              defaultMessage="hmm, the group you are trying to create is very
                similar to one you already have:"
            />
          </p>
        </div>
        {this.renderSimilarPurchase()}
        <div className="modal-section">
          {this.renderButtons()}
        </div>
      </div>
    );
  }
}

DuplicatedPurchase.defaultProps = {
  ignoreDuplicatedPurchase: () => {},
};

export default DuplicatedPurchase;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-claim/duplicated-purchase.js